
import { defineComponent, onMounted } from "vue";
import courtOrderList from "@/views/filiation/courtOrderList.vue";
import KTModalCard from "@/components/cards/Card.vue";
import modalFiliation from "@/views/filiation/modalFiliation.vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
//import { getIllustrationsPath } from "@/core/helpers/assets";

export default defineComponent({
  name: "filiation",
  components: {
    courtOrderList,
    KTModalCard,
    modalFiliation,
  },
  setup() {
    onMounted(() => {
      setCurrentPageBreadcrumbs("Filiación nueva persona", []);
    });

    return {
      //getIllustrationsPath,
    };
  },
});
